import * as THREE from 'three';
import { appendFaceBoundary, isModelMesh } from './viewport';

// OCCT's glTF writer gives each B-rep face its own vertices, so the edges a
// face's triangles use only once are its B-rep edges. Other writers promise no
// such split.
export function isOcctGltf(asset: { generator?: string }): boolean {
  return asset.generator?.startsWith('Open CASCADE') === true;
}

/** Line segments along every B-rep edge under `root`, in `root`'s own frame. */
export function brepEdgesGeometry(root: THREE.Object3D): THREE.BufferGeometry {
  root.updateWorldMatrix(true, true);
  const rootInverse = root.matrixWorld.clone().invert();
  const toRoot = new THREE.Matrix4();
  const positions: number[] = [];
  root.traverse((child) => {
    if (!isModelMesh(child)) return;
    toRoot.multiplyMatrices(rootInverse, child.matrixWorld);
    appendFaceBoundary(child, toRoot, positions);
  });
  return new THREE.BufferGeometry().setAttribute(
    'position',
    new THREE.Float32BufferAttribute(positions, 3),
  );
}
